"use client";

import React from "react";

import useAnalytics from "@/hooks/useAnalytics";

const Button = ({
  track: trackProps = null,
  children = null,
  onClick = null,
  as: Cmp = "button",
  ...props
}) => {
  const { track } = useAnalytics();

  const handleClick = React.useCallback(
    (e) => {
      // e.preventDefault();
      if (typeof onClick === "function") {
        onClick();
      }

      if (trackProps?.event) {
        track(trackProps.event, trackProps.meta);
      }

      return true;
    },
    [onClick, trackProps, track],
  );

  return (
    <Cmp
      onClick={handleClick}
      className={[
        props.className,
        "btn-rainbow text-white font-semibold text-md cursor-pointer",
      ].join(" ")}
      {...props}
    >
      {children}
    </Cmp>
  );
};

export default Button;
